module.exports = __webpack_public_path__ + "media/images/guide-5-7a3ea7a44658aba836f3dada4d290fab.png";